const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailValid = (value: string, required: boolean): boolean => {
  return (!required && value.length === 0) || emailRegex.test(value);
};
